import { normalizeClient } from './normalizeClient'

export const blankClient = normalizeClient()